import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/typedHooks";
import { trackDashboardViewed, trackPageViewed } from "./canonicalTracking";
import { runSessionAndAttributionBootstrap } from "./sessionAttribution";

const DASHBOARD_PATHS: Record<
  string,
  "earnings" | "analytics" | "payouts" | "subscribers"
> = {
  "/dashboard": "analytics",
  "/adminDashboard": "analytics",
  "/creator-payouts": "payouts",
  "/admin-payouts": "payouts",
  "/subscriptions": "subscribers",
};

export default function RouteAnalytics(): null {
  const location = useLocation();
  const lastRouteKey = useRef<string>("");
  const user = useAppSelector<any>(state => state.user.currentUser);
  const userType = user?.userType?.title?.toLowerCase?.() || "guest";

  useEffect(() => {
    const routeKey = `${location.pathname}${location.search}`;
    if (lastRouteKey.current === routeKey) return;
    lastRouteKey.current = routeKey;

    runSessionAndAttributionBootstrap({
      pathname: location.pathname,
      search: location.search,
      user_id: user?.id,
      user_type_title: userType,
    });

    trackPageViewed({
      path: location.pathname,
      user_id: user?.id,
      user_role: userType,
    });

    const dashboardType = DASHBOARD_PATHS[location.pathname];
    if (dashboardType) {
      trackDashboardViewed({
        dashboard_type: dashboardType,
        user_id: user?.id,
      });
    }
  }, [location.pathname, location.search, user?.id, userType]);

  return null;
}
